<template>
    <div class="healthRank" :class="{ bg_fff: !onlyList, onlyList: onlyList }">
        <div v-if="!onlyList">
            <p v-if="hasLine" class="homeComTitle hasLine">
                <span class="titleLine"></span>
                <span>{{ title }}</span>
            </p>
            <p v-else class="homeComTitle" :class="[ imgClass ]">{{ title }}</p>
            <p v-if="renderData && renderData.percentageList" class="mainContent" v-html="content"></p>
        </div>
        <section class="rankBox" v-if="renderData.list.length">
            <p class="font_hint co_666 fs12 mb6"><span>舆情健康指数</span><span class="float_r" :class="{mr16 : onlyList}">代表性企业</span>
            </p>
            <div class="rankList flex_box" v-for="(item, index) in renderData.list" :key="item.key + index">
                <img class="healthDescBg" :src="require('../../assets/img/health/healthRankBg' + index + '.png')"/>
                <div class="itemLeft">
                    <p class="itemTitle" @click="gotoDetail(index)">
                        <img class="lightIcon" src="../../assets/img/healthLight.png" alt="">
                        <span class="co_fff fs14 ">{{ !index ? '优秀' : index > 1 ? '一般' : '良好' }}  ></span>
                    </p>
                    <p class="fs12 mt3 score_range ml4">{{ item.label }}</p>
                </div>
                <div v-if="item.count > 0" class="itemRight flex_1 text_r co_ff8 fs14 font_n">
                    <p class="elli1 co_333 fs14"
                       v-for="subItem in (onlyList ? item.companies : item.companies.slice(0,5))"
                       :key="subItem">{{ subItem }}</p>
                </div>
                <div v-else class="itemRight flex_1 text_r fs14 font_n">
                    <p class="elli1 co_B0 fs14">该分段暂无企业</p>
                </div>
            </div>
        </section>
        <div v-if="getMore && renderData.list.length" class="text_c co_666"
             @click="$router.push({ path: '/enterpriseDistribution?industry=' + entity })">查看更多
        </div>
    </div>
</template>

<script>

import _ from "loadsh"
import common from "@/util/common";
export default {
    name: "HealthRank",
    props: {
        title: {
            type: String,
            default: '企业舆情健康指数分布'
        },
        imgClass: {
            type: String,
            default: 'textIcon'
        },
        periodStr: {
            type: String,
            default: '日'
        },
        entity: {
            type: String,
            default: '全行业'
        },
        renderData: Object,
        onlyList: Boolean,
        hasLine: Boolean,
        getMore: Boolean
    },
    data() {
        return {
            content: "",
        }
    },
    mounted() {
        this.industryStr = _.get(this.renderData, "industry", "");
        if (this.renderData && this.renderData.percentageList) {
            let { percentageList, companyCount } = this.renderData;
            if (percentageList.length) {
                this.content = `${common.formatDateStr(this.periodStr)}，系统监测覆盖全国${this.renderData.industry}行业${companyCount}家金融机构，其中有${percentageList[0].percentage}%的舆情健康情况为优秀、${percentageList[1].percentage}%为良好、${percentageList[2].percentage}%为一般。`
            }
        }
    },
    methods: {
        gotoDetail(index) {
            this.$router.push({
                name: 'EnterpriseDistributionDetail',
                params: {
                    list: this.renderData.list,
                    index: String(index),
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.healthRank {
    font-family: PingFangSC-Regular;
    padding: 20px 16px 0px 16px;
    .mainContent {
        margin-top: 12px;
    }

    .rankBox {
        //width: calc(100vw - 65px);
        margin: 32px auto;

        .rankList {
            width: 100%;

            .itemTitle {
                position: absolute;
                height: 24px;
                line-height: 24px;
            }

            .lightIcon {
                width: 9px;
                height: 10px;
                margin: 0 10px;
            }
        }

        .itemRight {
            padding-top: 5px;
            padding-bottom: 25px;

            .elli1 {
                line-height: 24px;
            }
        }
    }
}

.healthRank.onlyList {
    padding: 12px;

    .rankBox {
        width: calc(100vw - 20px);
        margin: 0;
        height: calc(100vh - 200px);

        .font_hint {
            margin-bottom: 8px;
        }

        .rankList {
            background-color: #FFFFFF;
            max-height: 32%;
            overflow: hidden;
            margin-bottom: 8px;

            .itemRight {
                padding-right: 16px;
                overflow-y: auto;
            }
        }
    }
}
.score_range {
    width: 100px;
    margin-top: 30px;
    margin-left: 10px;
    color: #376ccf;
}
</style>